import React from 'react'

export default props => (
    <tr {...props} style={{ ...props.style, backgroundColor: props.backgroundColor, color: props.color }}>
		{props.children}
	</tr>
)
